export const baseUrl =localStorage.getItem("Server");
// export const baseUrl = "https://moniro-backend-staging-gsixwphnia-lz.a.run.app";
export const stagingBaseUrl ="https://moniro-backend-staging-gsixwphnia-lz.a.run.app";
export const productionBaseUrl ="https://api.moniro.app";
// export const baseUrl='http://localhost:3000';
// export const stagingBaseUrl ="http://localhost:3000";
// export const productionBaseUrl='http://localhost:3000';
 export const access_token=localStorage.getItem('token');